<template>
  <div @click="$emit('input', !value)" class="custom-checkbox">
    <div ref="wrapper" class="icon-wrapper" :style="cssVars">
      <Checked v-if="value" class="icon" />
      <Unchecked v-else class="icon" />
    </div>
    <slot />
  </div>
</template>

<script>
import Checked from "@/assets/icons/checkbox-checked.svg";
import Unchecked from "@/assets/icons/checkbox-unchecked.svg";

export default {
  name: "Checkbox",

  components: { Checked, Unchecked },

  props: {
    value: Boolean,

    highlightKey: {
      type: Number,
      default: 0,
    },

    highlightDuration: {
      type: Number,
      default: 1200,
    },
  },

  computed: {
    cssVars() {
      return {
        "--highlight-duration": `${this.highlightDuration}ms`,
      };
    },
  },

  watch: {
    highlightKey() {
      this.restartAnimation();
    },
  },

  methods: {
    restartAnimation() {
      const el = this.$refs.wrapper;
      if (!el) return;

      el.classList.remove("highlight");

      void el.offsetWidth;

      el.classList.add("highlight");
    },
  },
};
</script>

<style scoped lang="less">
.custom-checkbox {
  display: flex;
  width: 100%;
  height: fit-content;
  gap: 10px;
  font-family: Montserrat;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 1;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  @media (max-width: 767px) {
    font-size: 14px;
  }

  .icon {
    min-width: 33px;
    min-height: 33px;
    margin: 4px;
    color: #a5d8ff;
  }

  .icon-wrapper {
    max-width: 33px;
    min-width: 33px;
    max-height: 33px;
    height: 33px;
    min-height: 33px;
    margin: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
  }

  .icon-wrapper.highlight {
    animation: checkboxPulse var(--highlight-duration) ease;
  }

  @keyframes checkboxPulse {
    0% {
      box-shadow: 0 0 0 0 rgba(248, 66, 66, 0.8);
      border-radius: 6px;
    }
    30% {
      box-shadow: 0 0 0 4px rgba(248, 66, 66, 0.8);
    }
    100% {
      box-shadow: 0 0 0 0 rgba(248, 66, 66, 0);
    }
  }
}
</style>
